<nav class="navbar navbar-expand-lg navbar-dark bg-dark">
    <a class="navbar-brand" routerLink= "user"><b>Github Search</b></a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
      <div class="navbar-nav">
        <a class="nav-item nav-link active" routerLink= "user" routerLinkActive='active'>User<span class="sr-only">(current)</span></a>
        <a class="nav-item nav-link" routerLink = "/repos" routerLinkActive='active'>Repositories</a>
      </div>
    </div>
  </nav>


